import global_axios from '../../funciones_globales/interaccionapi';
import { INICIALIZAR_FORM } from '../generales/actionTypes';
import  { CARGAR_ARTICULO, CARGAR_ARTICULOS, CARGAR_STOCKSARTICULO, CARGAR_RESERVASARTICULO } from './actionTypes';
import { VISUALIZAR_LOADING, VISUALIZAR_ALERTA } from '../generales/actionTypes';
import { generarItemCatalogoSeleccionado } from '../../funciones_globales/catalogos';
import { validarCampoString } from '../../funciones_globales/utils';

export const cargar_Articulo = (articulo) => {
	return (dispatch) => {
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios({
			url: '/articulos/' + articulo,
			method: 'GET'
		})
		.then( response => {
			let articulo = response.data;
			articulo.marca = (articulo.marca===null?null:generarItemCatalogoSeleccionado(articulo.marca.Codigo, articulo.marca.Descripcion));
			articulo.sublinea1 = (articulo.sublinea1===null?null:generarItemCatalogoSeleccionado(articulo.sublinea1.Codigo, articulo.sublinea1.Descripcion));
			articulo.sublinea2 = (articulo.sublinea2===null?null:generarItemCatalogoSeleccionado(articulo.sublinea2.Codigo, articulo.sublinea2.Descripcion));
			articulo.procedencia = (articulo.paisOrig===null?null:generarItemCatalogoSeleccionado(articulo.paisOrig.Codigo, articulo.paisOrig.Descripcion));
			articulo.proveedor = (articulo.prov===null?null:generarItemCatalogoSeleccionado(articulo.prov.Codigo, articulo.prov.Nombre));
			articulo.tipocompra = (articulo.tipoComp===null?null:generarItemCatalogoSeleccionado(articulo.tipoComp.Codigo, articulo.tipoComp.Descripcion));
			articulo.impuesto = (articulo.impArancel===null)?null:articulo.impArancel.Impuesto;
			articulo.coeficiente = (articulo.impArancel===null)?null:articulo.impArancel.Coefic;
			
			dispatch({
				type: CARGAR_ARTICULO,
				data: articulo
			});
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
		})
		.catch(error=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar artículo', mensaje: msgError}
			});
		});
	}
}

export const cargar_Articulos = (articulo, descripcion, codOriginal, codFabrica, vehiculosAplicacion) => {
	return (dispatch) => {
		
		let filtrosUrlArticulos = `tipo=catalogogeneral`;
		if(validarCampoString(articulo, 1, 10)){
			if(filtrosUrlArticulos.length>0){
				filtrosUrlArticulos += '&';
			}
			filtrosUrlArticulos += `articulo=${articulo}`;
		}

		if(validarCampoString(descripcion, 1, 80)){
			if(filtrosUrlArticulos.length>0){
				filtrosUrlArticulos += '&';
			}
			filtrosUrlArticulos += `descripcion=${descripcion}`;
		}

		if(validarCampoString(codOriginal, 1, 40)){
			if(filtrosUrlArticulos.length>0){
				filtrosUrlArticulos += '&';
			}
			filtrosUrlArticulos += `codoriginal=${codOriginal}`;
		}

		if(validarCampoString(codFabrica, 1, 40)){
			if(filtrosUrlArticulos.length>0){
				filtrosUrlArticulos += '&';
			}
			filtrosUrlArticulos += `codfabrica=${codFabrica}`;
		}

		if(validarCampoString(vehiculosAplicacion, 1, 80)){
			if(filtrosUrlArticulos.length>0){
				filtrosUrlArticulos += '&';
			}
			filtrosUrlArticulos += `vehiculosaplicacion=${vehiculosAplicacion}`;
		}

		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});

		return global_axios({
			url: `/articulos?${filtrosUrlArticulos}`,
			method: 'GET'
		})
		.then( response => {
			dispatch({
				type: CARGAR_ARTICULOS,
				data: response.data
			});
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
		})
		.catch(error=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar artículos', mensaje: msgError}
			});
		});
	}
}

export const cargar_ValoresIniciales = (fechaProceso) => {		
	return	{	type: INICIALIZAR_FORM,
				data: {	estado: 'A', 
						fecharegistro: fechaProceso,
						fechavencimiento: fechaProceso,
						gravaiva: true,
						empaque: 'UNI',
						unidporcaja: 1
					},
			}
}

export const inicializarArticulos = () => {		
	return	{	type: CARGAR_ARTICULOS,
				data: []
			}
}

export const inicializarArticulo = () => {
	return	{	type: CARGAR_ARTICULO,
				data: {}
			}
}

export const cambiarArancelDeArticulo = (articulo, codArancel) => {
	if(!validarCampoString(codArancel, 1, 20)){
		return {
			type: VISUALIZAR_ALERTA,
			data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar arancel', mensaje: 'El arancel no ha sido especificado correctamente.'}
		};
	}else{	
		return (dispatch) => {	
			return global_axios({
				url: `/aranceles/${codArancel}`,
				method: 'GET'
			})
			.then( response => {
				let articuloModif = {
					...articulo,
					coeficiente: response.data.Coefic!==null?response.data.Coefic:'',
					impuesto: response.data.Impuesto!==null?response.data.Impuesto:'',
				};			
				
				dispatch({
					type: CARGAR_ARTICULO,
					data: articuloModif
				});
			})
			.catch(error=>{
				let msgError = error.response?error.response.data.msg:error.message;			
				dispatch({
					type: VISUALIZAR_ALERTA,
					data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar arancel', mensaje: msgError}
				});
			});
		}
	}
}

export const cargar_StocksArticulo = (articulo) => {
	return (dispatch) => {
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios({
			url: `/articulos/${articulo}/stocks`,
			method: 'GET'
		})
		.then( response => {
			dispatch({
				type: CARGAR_STOCKSARTICULO,
				data: response.data
			});
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
		})
		.catch(error=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar stocks de artículo', mensaje: msgError}
			});
		});
	}
}

export const cargar_ReservasArticulo = (articulo) => {
	return (dispatch) => {
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios({
			url: `/articulos/${articulo}/reservas`,
			method: 'GET'
		})
		.then( response => {
			dispatch({
				type: CARGAR_RESERVASARTICULO,
				data: response.data
			});
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
		})
		.catch(error=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar reservas de artículo', mensaje: msgError}
			});
		});
	}
}
